
import { Options, prop, Vue } from "vue-class-component";
import Search from "@/app/ui/components/search/index.vue";
import DateRangePicker from "@/app/ui/components/date-range-picker/index.vue";
import { Range } from "@/app/ui/components/date-range-picker/type";
import { OptionsClass } from "@/domain/entities/MainApp";
import { DownloadReportRequest } from "@/domain/entities/Kulioner";
import DownloadWithDateRange from "../download-with-date-range/index.vue";

class Props {
  downloadButtonText = prop<string>({
    default: ""
  });
  showDownloadButton = prop<boolean>({
    default: true
  });
  showShipmentType = prop<boolean>({
    default: true
  });
  dateRange = prop<Range>({
    default: () => new Range(),
  });
  shipmentType = prop<OptionsClass[]>({
    default: () => []
  });
  search = prop<string>({
    default: ""
  });
  disableDownloadButton = prop<boolean>({
    default: false
  });
}

@Options({
  components: {
    Search,
    DateRangePicker,
    DownloadWithDateRange
  },
  emits: ["search", "update:shipmentType", "update:search", "update:dateRange", "filter", "apply-date", "reset-date", "enter"]
})
class HeaderFilterBar extends Vue.with(Props) {
  shipmentTypeSelect = false;
  shipmentTypes = [
    new OptionsClass({
      name: "AGGREGATOR",
      value: "AGGREGATOR"
    }),
    new OptionsClass({
      name: "MARKETPLACE",
      value: "MARKETPLACE"
    }),
    new OptionsClass({
      name: "CUSTOMER APP",
      value: "CUSTOMER_APP"
    }),
    new OptionsClass({
      name: "CORPORATE",
      value: "CORPORATE"
    }),
  ]

  get dateRangeModel() {
    return this.dateRange;
  }

  set dateRangeModel(value: any) {
    this.$emit("update:dateRange", value);
  }

  get resolvedDownloadButtonText() {
    return (
      this.downloadButtonText || this.$t("pickupDashboard.downloadDataCourier")
    );
  }

  onDownload(date: DownloadReportRequest) {
    this.$emit("download", date);
  }

  onSelectShipmentType() {
    this.$emit("update:shipmentType", this.shipmentType);
    this.$emit("filter");
  }

  onSearch(value = "") {
    if (!!value && value.length < 3) return;
    this.$emit("update:search", value);
    this.$emit("search");
  }
}
export default HeaderFilterBar;
